export enum IHotkeyTypes {
	addBoxEntity = 'b',
	removeEntities = 'Delete',
	removeEntitiesAlt = 'Backspace',
	propScale = 'Shift',
	allSidesScale = 'Alt',
	groupSelect = 'Shift',
	individualGroupRotation = 'r',
	individualGroupScale = 's',
	meta = 'Meta',
	copy = 'c',
	paste = 'v',
}

export const hotkeyIsPressed = (
	selectedKeys: string[],
	hotkeys: IHotkeyTypes[]
) => {
	return selectedKeys.includes(hotkeys[0]);
};
